<!-- statistics -->
<template>
  <div class="danmu-page">
    <div class="search-form">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="goSearch">
        <el-form-item label="查询月份">
          <el-form-item class="begin-item">
            <el-date-picker :editable="false" type="month" placeholder="选择月份" v-model="searchForm.beginTime" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item label="过滤未开播数据">
          <el-switch
            v-model="searchForm.filterOnline"
            on-text="开"
            off-text="关">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type='submit'>查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-alert
      title="数据说明"
      type="info"
      description="数据每日统计一次。受斗鱼API和采集周期所限：进入房间人数为10级以上数据；最高人气数、最高关注数为每日采集数据的最高值，采集间隔为5分钟可能并非当日极值。2017年9月试运行期间数据采集存在不稳定情况，其中1、2、3、14日的关注数为手动修复数据，且缺失大量开播情况数据。">
    </el-alert>
    <div style="margin-top: 20px" class="">
      <el-row>
        <el-col :span="12">
          <chart class="statistics-chart" :options="chartOption.danmuOption" ref="danmu"></chart>
        </el-col>
        <el-col :span="12">
          <chart class="statistics-chart" :options="chartOption.compositeOption" ref="composite"></chart>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 20px" class="">
      <el-table
        v-loading="loading"
        :data="statisticsList"
        stripe
        style="width: 100%"
        :default-sort = "{prop: 'calculatedDate', order: 'ascending'}"
      >
        <el-table-column
          prop="calculatedDate"
          label="统计日期"
          sortable
          :formatter="dateFormat"
        >
        </el-table-column>
        <el-table-column
          prop="danmuSum"
          label="弹幕总数"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="speakSum"
          label="发言人数"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="enterSum"
          label="进入房间人数"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="onlineMax"
          label="最高人气数"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="fansMax"
          label="最高关注数"
          sortable
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
    import moment from 'moment'
    import api from '../api/api'
    export default {
        created() {
          this.getStatisticsList();
        },
        data() {
            return {
              loading : false,
              searchForm : {
                beginTime : new Date(),
                filterOnline : true
              },
              statisticsList : [],
              chartOption : {
                compositeOption : {
                  title : {
                    text: '发言数、进入数、关注增幅数折线图',
                    left: 'center'
                  },
                  legend: {
                    show: true,
                    data:['发言数','进入数','关注增幅数'],
                    top  : 'bottom',
                    left : 'center'
                  },
                  tooltip: {
                    show: true
                  },
                  xAxis : [
                    {
                      type : 'time',
                      splitNumber : '10',
                      minInterval : 3600 * 24 * 1000,
                      maxInterval: 3600 * 24 * 7000
                    }
                  ],
                  yAxis : [
                    {
                      type : 'value'
                    }
                  ],
                  series : []
                },
                danmuOption : {
                  title : {
                    text: '弹幕数、人气数折线图',
                    left: 'center'
                  },
                  legend: {
                    show: true,
                    data:['弹幕数','人气数'],
                    top  : 'bottom',
                    left : 'center'
                  },
                  tooltip: {
                    show: true
                  },
                  xAxis : [
                    {
                      type : 'time',
                      splitNumber : '10',
                      minInterval : 3600 * 24 * 1000,
                      maxInterval: 3600 * 24 * 7000
                    }
                  ],
                  yAxis : [
                    {
                      type : 'value'
                    }
                  ],
                  series : []
                }
              },
            }
        },
        components: {},
        watch: {

        },
        computed: {

        },
        methods: {
          chart() {
            let composite = this.$refs.composite;
            let danmu = this.$refs.danmu;
            let spakArr = [];
            let enterArr = [];
            let danmuArr = [];
            let fansArr = [];
            let onlineArr = [];
            let lastFans = 0;
            if(this.statisticsList){
              this.statisticsList.forEach((value,index,arr) => {
                spakArr.push([value.calculatedDate,value.speakSum]);
                enterArr.push([value.calculatedDate,value.enterSum]);
                danmuArr.push([value.calculatedDate,value.danmuSum]);
                onlineArr.push([value.calculatedDate,value.onlineMax]);
                if(index === 0){
                  lastFans = value.fansMax
                }else {
                  lastFans = arr[index-1].fansMax
                }
                let fansNum = parseInt(value.fansMax - lastFans);
                fansArr.push([value.calculatedDate,fansNum])

              });
              this.chartOption.compositeOption.series = [];
              this.chartOption.compositeOption.series.push({
                name: '发言数',
                type: 'line',
                data: spakArr
              },{
                name: '进入数',
                type: 'line',
                data: enterArr
              },{
                name: '关注增幅数',
                type: 'line',
                data: fansArr
              });
              this.chartOption.danmuOption.series = [];
              this.chartOption.danmuOption.series.push({
                name: '弹幕数',
                type: 'line',
                data: danmuArr
              },{
                name: '人气数',
                type: 'line',
                data: onlineArr
              });
              composite.setOptions(this.chartOption.compositeOption);
              composite.setOptions(this.chartOption.danmuOption);
            }
          },
          getStatisticsList(){
            api.danmu.statisticsList({month:this.searchForm.beginTime,filterOnline:this.searchForm.filterOnline}).then(result =>{
              this.statisticsList = result.data.res;
              this.chart();
            }).catch(result =>{})
          },
          dateFormat: function (row) {
            return moment(row.calculatedDate).format('YYYY-MM-DD')
          },
          goSearch(){
            this.getStatisticsList();
          },
        }
    }
</script>
<style></style>



// WEBPACK FOOTER //
// statistics.vue?58832bf6